import { NavLink, Outlet, useOutletContext } from 'react-router-dom';
import { cn } from '@/lib/utils';
import { t } from '@/i18n';
import type { AppShellContext } from '@/components/layout/AppShell';

const TABS = [
  { to: '', end: true, labelKey: 'crm.tabs.leads' },
  { to: 'klienci', end: false, labelKey: 'crm.tabs.accounts' },
  { to: 'szanse', end: false, labelKey: 'crm.tabs.deals' },
] as const;

/**
 * Tabbed shell for the CRM module. Structural copy of MagazynLayout — the
 * outlet context MUST be forwarded, or every child page's useOutletContext()
 * comes back undefined (the 2026-07-23 black-screen incident).
 */
export function CrmLayout() {
  const context = useOutletContext<AppShellContext>();

  return (
    <div className="space-y-6">
      <nav className="flex gap-1">
        {TABS.map((tab) => (
          <NavLink
            key={tab.labelKey}
            to={tab.to}
            end={tab.end}
            className={({ isActive }) =>
              cn(
                'rounded-full px-4 py-1.5 text-sm font-medium transition-colors',
                isActive
                  ? 'bg-primary text-primary-foreground'
                  : 'text-muted-foreground hover:bg-muted hover:text-foreground',
              )
            }
          >
            {t(tab.labelKey)}
          </NavLink>
        ))}
      </nav>
      <Outlet context={context} />
    </div>
  );
}
